import { gql, useMutation } from '@apollo/client';
import { FormikHelpers } from 'formik';
import { nanoid } from "nanoid";
import { useState } from "react";
import { SquareLoader } from "react-spinners";
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { ValidationButton, ValidationForm, ValidationInput } from "../../components/form";

export default function Form() {

    
    const ADD_LOYAL_CUSTOMERS = gql`
    mutation addLoyalCustomers($data: AddLoyalCustomerInput!){
        addLoyalCustomer(data: $data){
            id
            fullName
            contact
            location
            email
        }
    }
    `
    const [agreedToTsCs, setAgreedToTsCs] = useState(false)
    const [
        addLoyalCustomer,
        {loading, error}
    ] = useMutation(ADD_LOYAL_CUSTOMERS, {errorPolicy: "all"})

    const validationSchema = Yup.object().shape({
        fullName: Yup.string().required(),
        email: Yup.string().email().required(),
        contact: Yup.string().required(),
        location: Yup.string().required(),
    })

    const initialValues={
        fullName:"",
        email: "",
        contact: "",
        location:""
    }

    const handleOnSubmit = async(values: typeof initialValues, helpers:FormikHelpers<any>)=>{
        const userData = {
            id: nanoid(),
            ...values
        }

        await addLoyalCustomer({variables: {data: userData}})
        if(error){
            toast.error("Failed to create account")
        }else{
            toast.success("You have been successfully subscribed to our newsletter.🎉")
            helpers.resetForm()
        }
    }

  return (
    <ValidationForm
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        validationSchema={validationSchema}
    >
        <div className="w-full mt-10 bg-primary p-6 lg:px-12 lg:flex-1">
            
            <ValidationInput name="fullName" type="text" placeholder="Full Name" />
            <ValidationInput name="email" type="email" placeholder="Email" />
            <ValidationInput name="contact" type="text" placeholder="Contact" />
            <ValidationInput name="location" type="text" placeholder="Location" />
            <label htmlFor="agree_to_t&c" className="flex items-center mt-16 text-sm text-white">
                <input 
                    type="checkbox" 
                    checked={agreedToTsCs} 
                    name="agree_to_t&c" 
                    id="agree_to_t&c" 
                    className='accent-black'
                    onChange={()=>setAgreedToTsCs(!agreedToTsCs)}
                />
                &nbsp; I Agree to &nbsp; <a href="/termsandconditions" className="font-bold underline">Terms and Conditions</a>.
            </label>
            <ValidationButton disabled={!agreedToTsCs} >
                {
                    !loading ? "Submit" : <SquareLoader color="rgba(255,255,255,0.5)" size={16} />
                }
            </ValidationButton>
        </div>
    </ValidationForm>
  )
}
